import React, { Component } from "react";
import { OBNotificationData } from "../../../types/OBTypes";
import { ReduxConnect, Styled } from "../../../toolkit/decorators/Artifact";
import { obNotificationStore } from "./OBNotification.store";
import s from "./OBNotification.styles.scss";
import close from "../../media/images/close.png";
import error from "../../media/images/error.png";
import success from "../../media/images/success.png";

interface Props {
  notification: OBNotificationData;
}

interface State {
  notification: OBNotificationData;
}

@ReduxConnect(obNotificationStore, () => {})
@Styled(s)
export default class OBNotification extends Component<Props, State> {
  state = {
    notification: null as OBNotificationData
  };

  componentDidUpdate(prevProps: Readonly<Props>): void {
    if (prevProps.notification !== this.props.notification) {
      let title = this.props.notification.title;

      if (!title) {
        title =
          this.props.notification.type === "error"
            ? "¡Se produjo un error!"
            : "¡Registro exitoso!";
      }
      const notification = {
        ...this.props.notification,
        title
      };
      this.setState({ notification });
    }
  }

  render() {
    if (!this.state.notification) {
      return null;
    }

    return (
      <div
        onClick={() => this.setState({ notification: null })}
        className={s.obNotificationRoot}
      >
        <div onClick={e => e.stopPropagation()} className={`${s.container}`}>
          <div className={`${s.header}`}>
            <span onClick={() => this.setState({ notification: null })}>
              <img src={close} alt="x" />
            </span>
          </div>
          <div className={`${s.icon}`}>
            {this.state.notification.type === "error" ? (
              <img src={error} alt="Error" />
            ) : (
              <img src={success} alt="Success" />
            )}
          </div>
          <div className={`${s.title}`}>{this.state.notification.title}</div>
          <div className={`${s.message}`}>
            {this.state.notification.message}
          </div>
        </div>
      </div>
    );
  }
}
